import {
  CheckinCycleStatus,
  ICreateCheckinCyclePayload,
} from '@pages/dashboard/company-legacy/company-components/company-checkins/company-checkins.interface';
import {CreateCheckinCycleFormData} from './types';
import {buildContentFromBlocks} from './content-payload';
import {buildCadenceConfig} from './cadence-payload';

export const buildPayload = (
  data: CreateCheckinCycleFormData,
  status: CheckinCycleStatus | string,
  contentData?: ReturnType<typeof buildContentFromBlocks>,
) => {
  const {content, params} =
    contentData ?? buildContentFromBlocks(data.contentBlocks);

  const payload: ICreateCheckinCyclePayload = {
    cycleName: data.cycleName?.trim() || '',
    params,
    visibility: (data.visibility || 'private') as
      | 'private'
      | 'public'
      | 'anonymous',
    status,
    allowLateSubmission: false,
    includedGroups: data.includeScope.includes('groups')
      ? data.includeGroups.map((group) => group.value)
      : [],
    includedIndividuals: data.includeScope.includes('individuals')
      ? data.includePeople.map((person) => person.value)
      : [],
    excludedGroups: data.excludeScope.includes('groups')
      ? data.excludeGroups.map((group) => group.value)
      : [],
    excludedIndividuals: data.excludeScope.includes('individuals')
      ? data.excludePeople.map((person) => person.value)
      : [],
    content,
    config: buildCadenceConfig(data.cadence),
  };

  return payload;
};
